<div id="strength">
  <small jhiTranslate="global.messages.validate.newpassword.strength">Password strength:</small>
  <ul id="strengthBar">
    <li class="point"></li>
    <li class="point"></li>
    <li class="point"></li>
    <li class="point"></li>
    <li class="point"></li>
  </ul>
</div>
